export default "__VITE_ASSET__BLboYMI7__"